export const pick = (v, lang) => (typeof v === "string" ? v : v?.[lang] ?? v?.it ?? "");

export const scrollToId = (id) => {    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const isOpenNow = () => {
    const now = new Date();
    const day = now.getDay();
    const mins = now.getHours() * 60 + now.getMinutes();
    const ranges = {
        0: [],
        1: [[660, 960]],
        2: [[660, 1440]],
        3: [[660, 1440]],
        4: [[660, 1440]],
        5: [[660, 1440]],
        6: [[1080, 1440]],
    };
    return (ranges[day] || []).some(([a, b]) => mins >= a && mins < b);
};
